import React from 'react';
export function AboutSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-17">
      <div className="max-w-3xl mx-auto text-center" data-id="element-18">
        <div className="text-4xl mb-6" data-id="element-19">🎵</div>
        <h2 className="text-3xl font-black text-brand-text mb-8" data-id="element-20">
          Sobre Música Lista
        </h2>
        <p className="text-lg text-brand-gray leading-relaxed" data-id="element-21">
          Nacimos con una misión clara: devolverle el tiempo y la paz mental a
          los docentes de música en Latinoamérica. Sabemos lo que es correr de
          escuela en escuela, planificar clases a la noche y sentir que los
          alumnos no conectan. Música Lista es el sistema estructurado que nos
          hubiera gustado tener cuando empezamos a enseñar.
        </p>
      </div>
    </section>;
}